import { useState, useEffect, memo } from 'react';
import axiosAWS from '../../api/configAxios.js';
import Cookie from "js-cookie";
import Select2 from "./select2.js";
import Swal from 'sweetalert2';
import $ from 'jquery';

var Select2_i_Gtablero_user_get = []
var Select2_i_Gtablero_tablero_get = []
var Select2_u_Gtablero_user_get = []
var Select2_u_Gtablero_tablero_get = []

const ModalesInsertsData = (params) => {

    const [loadUserIn, setLoadUserIn] = useState(false);
    const [cargahtml, setCargaHtml] = useState(false);

    ////////
    const [LoadIUser, setLoadIUser] = useState(false);
    const [LoadIRol, setLoadIRol] = useState(false);
    const [LoadITablero, setLoadITablero] = useState(false);
    const [LoadIGUser, setLoadIGUser] = useState(false);
    const [LoadIGTablero, setLoadIGTablero] = useState(false);
    const [PassVw, setPassVw] = useState(false);
    const [PassVwE, setPassVwE] = useState(false);
    const [PassUpd, setPassUpd] = useState(false);

    const [LoadDelete, setLoadDeleteo] = useState(false);


    ///
    const [LoadUpUser, setLoadUpUser] = useState(false);
    const [LoadUpRol, setLoadUpRol] = useState(false);
    const [LoadUpTablero, setLoadUpTablero] = useState(false);
    const [LoadUpGUser, setLoadUpGUser] = useState(false);
    const [LoadUpGTablero, setLoadUpGTablero] = useState(false);


    /// selects
    const [Select2_i_Gtablero_user, setSelect2_i_Gtablero_user] = useState(null);
    const [Select2_i_Gtablero_tablero, setSelect2_i_Gtablero_tablero] = useState(null);
    const [Select2_u_Gtablero_user, setSelect2_u_Gtablero_user] = useState(null);
    const [Select2_u_Gtablero_tablero, setSelect2_u_Gtablero_tablero] = useState(null);



    //load carga grupos
    const [LoadgtUser, setLoadgtUser] = useState(null);
    const [LoadgtTablero, setLoadgtTablero] = useState(null);

    /// varibles de contenido, seleecionado select2
    //const [Select2_i_Gtablero_user_get, setSelect2_i_Gtablero_user_get] = useState();

    const setSelect2_i_Gtablero_user_get = (_data) => {
        // este get le pertenece a Select2_i_Gtablero_user
        Select2_i_Gtablero_user_get = _data
    }

    const setSelect2_i_Gtablero_tablero_get = (_data) => {
        // este get le pertenece a Select2_i_Gtablero_user
        Select2_i_Gtablero_tablero_get = _data
    }

    const setSelect2_u_Gtablero_user_get = (_data) => {
        // este get le pertenece a Select2_i_Gtablero_user
        Select2_u_Gtablero_user_get = _data
    }

    const setSelect2_u_Gtablero_tablero_get = (_data) => {
        // este get le pertenece a Select2_i_Gtablero_user
        Select2_u_Gtablero_tablero_get = _data
    }

    const get_data_consulta = async (url, data) => {
        var result = null;
        try {
            const cookies = Cookie.get();
            var result_auth = null;

            result_auth = await axiosAWS.post(url, data, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                    //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    ////console.log("algo anda mal con la el servidor");
                }
            });

            ////console.log(result_auth);

            if (result_auth.status >= 200 || result_auth.status <= 299) {
                if (result_auth.data.hasOwnProperty("result")) {
                    if (result_auth.data.result !== null) {
                        result = result_auth.data.result;

                    } else {
                        alert("sin datos presentes");
                    }

                }

            } else {
                alert("usuario denegado");
            }

            return result;
        } catch (error) {

            //console.log("error servidorAWS");
            return "error";
        }
    }


    ///get
    const get_rols = async () => {

        if (!document.getElementById("MU-Ca")) {
            return
        }

        document.getElementById("MU-Ca").innerHTML = '<option value="">cargando...</option>';
        document.getElementById("MU-Ca-2").innerHTML = '<option value="">cargando...</option>';
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_roles_all" });
        result_tbl = result_tbl[0]
        ////console.log(result_tbl);

        if (result_tbl.length === 0) {
            //alert("Ups, algo salió mal. Inténtalo otra vez o comprueba el tablero que deseas visualizar")
            document.getElementById("MU-Ca").innerHTML = '<option value="">sin registros</option>';
            return
        }

        var add_html = "";
        result_tbl.forEach(row => {
            add_html += `
            <option value="`+ row.uuid + `">` + row.titulo + `</option>
            `;
        });

        if (!document.getElementById("MU-Ca")) {
            return
        }

        document.getElementById("MU-Ca").innerHTML = add_html;
        document.getElementById("MU-Ca-2").innerHTML = add_html;

    }

    const get_Gtableros = async () => {

        setSelect2_i_Gtablero_user(null)
        setSelect2_i_Gtablero_tablero(null)
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_all" });
        result_tbl = result_tbl[0]
       //console.log(result_tbl)
        var options = [];
        result_tbl.forEach(row => {
            options.push({ value: row.uuid, label: row.titulo })
        });

        setSelect2_i_Gtablero_user(<Select2 options={options} set_data={setSelect2_i_Gtablero_user_get} multi={true} name="IdGTablero" id="MU-GU" required />)
        setSelect2_i_Gtablero_tablero(<Select2 options={options} set_data={setSelect2_i_Gtablero_tablero_get} multi={true} name="IdGTablero" id="MT-GT" required />)
        //setSelect2_u_Gtablero_user(<Select2 options={options} set_data={setSelect2_u_Gtablero_user_get} multi={true} name="IdGTablero" id="MU-GU" required />)
        //setSelect2_u_Gtablero_tablero(<Select2 options={options} set_data={setSelect2_u_Gtablero_tablero_get} multi={true} name="IdGTablero" id="MT-GT" required />)



    }

    ///insert

    const insert_user = async (e) => {

        e.preventDefault();
        setLoadIUser(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "user";
        data_set["Gtableros"] = Select2_i_Gtablero_user_get;
        ////console.log(data_set);

        if (data_set.Nombre === "" && data_set.Correo === "" && data_set.password === "") {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'campos vacios, valida la información',
                timer: 4000
            });
            setLoadIUser(false);
            return
        }

        if (Select2_i_Gtablero_user_get.length === 0) {

            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'Debes de elegir al menos un grupo de tableros',
                timer: 4000
            });

            setLoadIUser(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/add-element/", data_set);
        var result_alert_email = await get_data_consulta("correo-notificacion", data_set);

       //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            setLoadIUser(false);
            return
        }

        if (!result_insert[0].hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadIUser(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'usuario creado',
            timer: 4000
        });
        //alert("usuario creado");

        params.get_users();
        e.target.reset();

        setLoadIUser(false);
        document.getElementById("closeb1").click();
        carga_catalogos();
    }

    const insert_rol = async (e) => {

        e.preventDefault();
        setLoadIRol(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "rol";
        ////console.log(data_set);

        if (data_set.Cargo === "") {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'campos vacios, valida la información',
                timer: 4000
            });
            //alert('campos vacios, valida la información');
            setLoadIRol(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/add-element/", data_set);

       //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadIRol(false);
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadIRol(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Rol creado',
            timer: 4000
        });

        //alert("rol creado");
        params.get_rols();
        e.target.reset();

        setLoadIRol(false);
        document.getElementById("closeb2").click();
        carga_catalogos();
    }

    const insert_tablero = async (e) => {

        e.preventDefault();
        setLoadITablero(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "tablero";
        data_set["Gtableros"] = Select2_i_Gtablero_tablero_get;
       //console.log(data_set);

        if (Select2_i_Gtablero_tablero_get.length === 0) {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'Debes de elegir al menos un grupo de tableros',
                timer: 4000
            });
            setLoadIUser(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/add-element/", data_set);

       //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadITablero(false);
            return
        }

        if (!result_insert[0][0].hasOwnProperty("agregado")) {
            alert('existio un error al cargar el registro, verifica que la URL');
            setLoadITablero(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Tablero creado',
            timer: 4000
        });

        //alert("tablero creado");
        params.get_tableros();
        e.target.reset();

        setLoadITablero(false);
        document.getElementById("closeb3").click();
        carga_catalogos();
    }

    const insert_gtablero = async (e) => {

        e.preventDefault();
        setLoadIGTablero(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "gtablero";
        ////console.log(data_set);

        var result_insert = await get_data_consulta("panel-control/add-element/", data_set);

        //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadIGTablero(false);
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadIGTablero(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Grupo tablero creado',
            timer: 4000
        });

        //alert("grupo tablero creado");
        params.get_Gtableros();
        e.target.reset();

        setLoadIGTablero(false);
        document.getElementById("closeb5").click();
        carga_catalogos();
    }

    const vw_password = (e) => {
        if (!PassVw) {
            //add = '<i class="bi bi-eye-slash-fill"></i>';
            setPassVw(true);
            //document.getElementById("pass-int").type = "text";
        } else {
            //add = '<i class="bi bi-eye-fill"></i>';
            setPassVw(false);
            //document.getElementById("pass-int").type = "password";
        }
    }

    const vw_passwordE = (e) => {
        if (!PassVwE) {
            //add = '<i class="bi bi-eye-slash-fill"></i>';
            setPassVwE(true);
            //document.getElementById("pass-intE").type = "text";
        } else {
            //add = '<i class="bi bi-eye-fill"></i>';
            setPassVwE(false);
            //document.getElementById("pass-intE").type = "password";
        }
    }

    const pass_update = (e) => {

        //console.log(e.target.checked);
        if (e.target.checked) {
            setPassUpd(true);
        } else {
            setPassUpd(false);
        }
    }

    const check_est = (e) => {
        if (e.target.checked) {
            document.getElementById("fSCheckCheckedEsLab").innerHTML = "On";
        } else {
            document.getElementById("fSCheckCheckedEsLab").innerHTML = "Off";
        }
    }

    /// update
    const update_user = async (e) => {

        e.preventDefault();
        setLoadUpUser(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "user";
        data_set["uuid"] = (params.get_registroS())[0];
        data_set["Gtableros"] = Select2_u_Gtablero_user_get;

        if (!data_set.hasOwnProperty("Estatus")) {
            data_set["Estatus"] = "0";
        }

        if (!data_set.hasOwnProperty("password")) {
            data_set["password"] = params.get_registroPaS();
        }

        ////console.log(data_set);


        if (data_set.Nombre === "" && data_set.Correo === "") {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'campos vacios, valida la información',
                timer: 4000
            });
            //alert('campos vacios, valida la información');
            setLoadUpUser(false);
            return
        }

        if (Select2_u_Gtablero_user_get.length === 0) {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'Debes de elegir al menos un grupo de tableros',
                timer: 4000
            });
            setLoadUpUser(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/edit-element/", data_set);
        if (data_set.hasOwnProperty("fSCheckChecked")){
            var data_set_email = data_set;
            data_set_email["type"] = "user_update"
            var result_alert_email = await get_data_consulta("correo-notificacion", data_set_email);
        }
        


        //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpUser(false);
            return
        }

        if (!result_insert[0].hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpUser(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Usuario actualizado',
            timer: 4000
        });

        //alert("usuario actualizado");
        params.get_users();
        e.target.reset();

        setLoadUpUser(false);
        document.getElementById("closeb7").click();
        carga_catalogos();
        
        setPassUpd(false);
        if(document.getElementById("fSCheckCheckedPassUp")){
            document.getElementById("fSCheckCheckedPassUp").checked = false
        }

    }

    const update_rol = async (e) => {

        e.preventDefault();
        setLoadUpRol(true)
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "rol";
        data_set["uuid"] = (params.get_registroS())[0];
        ////console.log(data_set);

        if (data_set.Cargo === "") {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'campos vacios, valida la información',
                timer: 4000
            });
            //alert('campos vacios, valida la información');
            setLoadUpRol(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/edit-element/", data_set);

       //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpRol(false);
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpRol(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Rol actualizado',
            timer: 4000
        });
        //alert("rol actualizado");
        params.get_rols();
        e.target.reset();

        setLoadUpRol(false);
        document.getElementById("closeb8").click();
        carga_catalogos();
    }

    const update_tablero = async (e) => {

        e.preventDefault();
        setLoadUpTablero(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "tablero";
        data_set["uuid"] = (params.get_registroS())[0];
        data_set["Gtableros"] = Select2_u_Gtablero_tablero_get;

        if (!data_set.hasOwnProperty("Estatus")) {
            data_set["Estatus"] = "0";
        }

        ////console.log(data_set);

        if (Select2_u_Gtablero_tablero_get.length === 0) {
            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Info',
                text: 'Debes de elegir al menos un grupo de tableros',
                timer: 4000
            });
            setLoadUpUser(false);
            return
        }

        var result_insert = await get_data_consulta("panel-control/edit-element/", data_set);

        //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpTablero(false);
            return
        }

        if (!result_insert[0].hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpTablero(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Tablero actualizado',
            timer: 4000
        });

        //alert("tablero actualizado");
        params.get_tableros();
        e.target.reset();

        setLoadUpTablero(false);
        document.getElementById("closeb9").click();
        carga_catalogos();
    }

    const update_gtablero = async (e) => {

        e.preventDefault();
        setLoadUpGTablero(true);
        const data = new FormData(e.target);
        //obtenemos los datos del formulario
        var data_set = {};
        data.forEach((value, key) => {
            data_set[key] = value;
        });
        data_set["type"] = "gtablero";
        data_set["uuid"] = (params.get_registroS())[0];

        if (!data_set.hasOwnProperty("Estatus")) {
            data_set["Estatus"] = "0";
        }
        ////console.log(data_set);

        var result_insert = await get_data_consulta("panel-control/edit-element/", data_set);

        //console.log(result_insert)

        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpGTablero(false);
            return
        }

        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al cargar el registro');
            setLoadUpGTablero(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Grupo tablero creado',
            timer: 4000
        });

        //alert("grupo tablero actualizado");
        params.get_Gtableros();
        e.target.reset();

        setLoadUpGTablero(false);
        document.getElementById("closeb11").click();
        carga_catalogos();
    }

    const carga_catalogos = async () => {
        get_Gtableros();
        if (document.getElementById("MU-Ca")) {
            get_rols();
        }
    }

    const change_options_update_tablero = async () => {
        setLoadgtTablero(true);
        setSelect2_u_Gtablero_tablero(null)
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_all" });
        result_tbl = result_tbl[0]

        var options = [];
        result_tbl.forEach(row => {
            options.push({ value: row.uuid, label: row.titulo })
        });

        try {
            // option select
            var options_select = [];
            var get_array = await params.get_gtableros_filt_tablero((params.get_registroS())[0]);
            get_array.forEach(row => {
                options_select.push({ value: row.uuid_grupo_tablero, label: row.Gtablero_titulo })
            });
            setSelect2_u_Gtablero_tablero(<Select2 options={options} set_data={setSelect2_u_Gtablero_tablero_get} selects={options_select} multi={true} name="IdGTablero" id="MT-GT" required />)
            Select2_u_Gtablero_tablero_get = options_select
        } catch (error) {
           //console.log(error)
            setSelect2_u_Gtablero_tablero("error")
        }
        setLoadgtTablero(false);

    }

    const change_options_update_user = async () => {
        setLoadgtUser(true);
        setSelect2_u_Gtablero_user(null)
        var result_tbl = await get_data_consulta("catalogos/", { type: "Cat_Gtableros_all" });
        result_tbl = result_tbl[0]

        var options = [];
        result_tbl.forEach(row => {
            options.push({ value: row.uuid, label: row.titulo })
        });

        try {
            // option select
            var options_select = [];
            var get_array = await params.get_gtableros_filt_user((params.get_registroS())[0]);
            get_array.forEach(row => {
                options_select.push({ value: row.uuid_grupo_tablero, label: row.titulo })
            });
            setSelect2_u_Gtablero_user(<Select2 options={options} set_data={setSelect2_u_Gtablero_user_get} selects={options_select} multi={true} name="IdGTablero" id="MT-GT" required />)
            Select2_u_Gtablero_user_get = options_select
        } catch (error) {
           //console.log(error)
            setSelect2_u_Gtablero_user("error")
        }
        setLoadgtUser(false);

    }




    useEffect(() => {
        if (document.getElementById("MU-Ca")) {
            setCargaHtml(true);
            get_rols();
        }
        get_Gtableros();

    }, [cargahtml])

    return (

        <>
            <div className="modal fade" id="m_usuariosI" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Agregar Usuario</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb1' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { insert_user(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Al agregar un nuevo usuario, se recargara el apartado.
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Nombre:</label>
                                        <input name="Nombre" type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">E-mail:</label>
                                        <input name="Correo" type="email" className="form-control" required />
                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <label className="txt_label">Cargo:</label>
                                        <select name="IdCargo" className="form-select" id="MU-Ca" required>

                                        </select>
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Contraseña:</label>
                                        <div className="input-group mb-3">
                                            {
                                                PassVw ?
                                                    <input type="text" name='password' className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />
                                                    :
                                                    <input type="password" name='password' className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />

                                            }

                                            <button className="btn btn-outline-secondary" type="button" id="button-addon2" title='ver contraseña' onClick={(e) => { vw_password(e) }}>
                                                {
                                                    PassVw ?
                                                        <i className="bi bi-eye-fill"></i>
                                                        :
                                                        <i className="bi bi-eye-slash-fill"></i>

                                                }

                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Grupos de Tableros:</label>

                                        {Select2_i_Gtablero_user}

                                        {/** 
                                        <select name="IdGUsuario" className="form-select form-select-sm" id="MU-GU" required>
                                        </select>
                                        */}

                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadIUser}>{LoadIUser ? "enviando..." : "Agregar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_rolesI" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Agregar Rol</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb2' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { insert_rol(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Al agregar un nuevo rol, se recargara el apartado.
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Cargo:</label>
                                        <input name="Rol" type="text" className="form-control" required />
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadIRol}>{LoadIRol ? "enviando..." : "Agregar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_tableroI" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Agregar Tablero</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb3' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { insert_tablero(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Al agregar un nuevo tablero, se recargara el apartado.<br></br>
                                        Para incluir un tablero aquí, debes crearlo previamente en Power BI de Microsoft y configurarlo para que sea público.
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Titulo:</label>
                                        <input name="Titulo" type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Grupo del tablero:</label>

                                        {Select2_i_Gtablero_tablero}

                                        {/**
                                          
                                         <select name="IdGTablero" className="form-select form-select-sm" id="MT-GT" required>

                                        </select> 
                                          
                                        */}

                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">URL:</label>
                                        <input name="Url" type="url" className="form-control" required />
                                    </div>

                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Descripción:</label>
                                        <textarea name="Nota" className="form-control" rows={5} required></textarea>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadITablero}>{LoadITablero ? "enviando..." : "Agregar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_GTablerosI" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Agregar Grupo de Tableros</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb5' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { insert_gtablero(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Al agregar un nuevo grupo de tableros, se recargara el apartado.
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Titulo:</label>
                                        <input name="Titulo" type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Descripción:</label>
                                        <textarea name="Nota" className="form-control" rows={5} required></textarea>
                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadIGTablero}>{LoadIGTablero ? "enviando..." : "Agregar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>



            {/**delete */}
            <div className="modal fade" id="m_deleteE" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="title_delete">Eliminar elemento</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb6' aria-label="Close" />
                        </div>

                        <div className="modal-body text-center">
                            <label>¿Estas seguro de eliminar el registro?</label><br></br><br></br>

                            <label className='text-title-001 fs-6' id='tipo_l'></label><br></br>
                            <label className='text-title-001' id='nombre_titulo_l'></label>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                            <button className="btn btn-primary" id='delete_element' onClick={() => { params.delete_element() }}>Eliminar</button>
                        </div>

                    </div>
                </div>
            </div>


            {/**update */}
            <div className="modal fade" id="m_usuariosUpd" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Editar Usuario</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb7' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { update_user(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Los cambios realizados al perfil de un usuario se verán reflejados inmediatamente, la cual se actualizará automáticamente.
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Nombre:</label>
                                        <input name="Nombre" id='nameUp' type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">E-mail:</label>
                                        <input name="Correo" id='correoUp' type="email" className="form-control bg-secondary-subtle" required readOnly />
                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <label className="txt_label">Cargo:</label>
                                        <select name="IdCargo" className="form-select" id="MU-Ca-2" required>

                                        </select>
                                    </div>

                                    <div className="col-sm-12  mb-4">
                                        <label className="txt_label">Grupos de Tableros:</label>

                                        <div className='row g-0'>
                                            <div className='col-1 text-end'>
                                                <button type="button" id='r-gt-u-up-replt' onClick={() => { change_options_update_user() }} class="btn btn-outline-secondary w-100 p-0 h-100" disabled={LoadgtUser}>
                                                    {
                                                        LoadgtUser ?
                                                            <i className="bi bi-cloud-download"></i>
                                                            :
                                                            <i className="bi bi-arrow-clockwise"></i>
                                                    }

                                                </button>
                                            </div>
                                            <div className='col-11'>
                                                {
                                                    Select2_u_Gtablero_user === null || Select2_u_Gtablero_user === "error" ?
                                                        Select2_u_Gtablero_user === "error" ?
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <label className='text-primary'>¡Ups! no pudimos cargar los datos</label>
                                                            </div>
                                                            :
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <img src="./img/progress-unscreen.gif" width={"80px"} />
                                                            </div>
                                                        :
                                                        Select2_u_Gtablero_user
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-6 md-2'>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name='fSCheckChecked' value={"1"} type="checkbox" role="switch" id="fSCheckCheckedPassUp" onChange={(e) => pass_update(e)} />
                                            <label className="form-check-label" htmlFor="fSCheckCheckedPassUp">Cambiar contraseña</label>
                                        </div>

                                        {
                                            !PassUpd ?
                                                <></>
                                                :
                                                <>
                                                    <label className="txt_label">Contraseña:</label>
                                                    <div className="input-group mb-3">
                                                        {
                                                            PassVwE ?
                                                                <input type="text" name='password' className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />
                                                                :
                                                                <input type="password" name='password' className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />

                                                        }
                                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2" title='ver contraseña' onClick={(e) => { vw_passwordE(e) }}>
                                                            {
                                                                PassVwE ?
                                                                    <i className="bi bi-eye-fill"></i>
                                                                    :
                                                                    <i className="bi bi-eye-slash-fill"></i>

                                                            }

                                                        </button>
                                                    </div>
                                                </>

                                        }

                                    </div>

                                    <div className='col-sm-6 md-2'>
                                        <label className="txt_label">Estatus:</label>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name='Estatus' value={"1"} type="checkbox" role="switch" id="fSCheckCheckedEs" onChange={(e) => { check_est(e) }} />
                                            <label className="form-check-label" htmlFor="fSCheckCheckedEs" id='fSCheckCheckedEsLab'>Off</label>
                                        </div>

                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadUpUser}>{LoadUpUser ? "enviando..." : "Actualizar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_rolesUpd" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Editar Rol</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb8' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { update_rol(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Los cambios realizados al registro se verán reflejados inmediatamente, la cual se actualizará automáticamente.
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Cargo:</label>
                                        <input name="Rol" id='CargoUp' type="text" className="form-control" required />
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadUpRol}>{LoadUpRol ? "enviando..." : "Actualizar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_tableroUpd" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Actualizar Tablero</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb9' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { update_tablero(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Los cambios realizados al registro se verán reflejados inmediatamente, la cual se actualizará automáticamente.
                                    </div>
                                    <div className='col-sm-6 md-2'>
                                        <label className="txt_label">Estatus:</label>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name='Estatus' value={"1"} type="checkbox" role="switch" id="fSCheckCheckedEstable" onChange={(e) => { check_est(e) }} />
                                            <label className="form-check-label" htmlFor="fSCheckCheckedEs" id='fSCheckCheckedEsLabEstable'>Off</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Titulo:</label>
                                        <input name="Titulo" id='TituloUp' type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">URL:</label>
                                        <input name="Url" id="UrlUp" type="url" className="form-control" required />
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Grupos del Tableros:</label>
                                        <div className='row g-0'>
                                            <div className='col-1 text-end'>
                                                <button type="button" id='r-gt-t-up-replt' onClick={() => { change_options_update_tablero(); }} class="btn btn-outline-secondary w-100 p-0 h-100" disabled={LoadgtTablero}>
                                                    {
                                                        LoadgtTablero ?
                                                            <i className="bi bi-cloud-download"></i>
                                                            :
                                                            <i className="bi bi-arrow-clockwise"></i>
                                                    }

                                                </button>
                                            </div>
                                            <div className='col-11'>
                                                {
                                                    Select2_u_Gtablero_tablero === null || Select2_u_Gtablero_tablero === "error" ?
                                                        Select2_u_Gtablero_tablero === "error" ?
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <label className='text-primary'>¡Ups! no pudimos cargar los datos</label>
                                                            </div>
                                                            :
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <img src="./img/progress-unscreen.gif" width={"80px"} />
                                                            </div>
                                                        :
                                                        Select2_u_Gtablero_tablero
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Descripción:</label>
                                        <textarea name="Nota" id="Notaup" className="form-control" rows={5} required></textarea>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadUpTablero}>{LoadUpTablero ? "enviando..." : "Actualizar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="m_GTablerosUpd" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 txt_label_titulo" id="exampleModalLabel">Actualizar Grupo de Tableros</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='closeb11' aria-label="Close" />
                        </div>
                        <form onSubmit={(e) => { update_gtablero(e) }}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12  mb-2 text-secondary">
                                        <i className="bi bi-info-circle"></i> Los cambios realizados al registro se verán reflejados inmediatamente, la cual se actualizará automáticamente.
                                    </div>
                                    <div className='col-sm-6 md-2'>
                                        <label className="txt_label">Estatus:</label>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name='Estatus' value={"1"} type="checkbox" role="switch" id="fSCheckCheckedEsgtablero" onChange={(e) => { check_est(e) }} />
                                            <label className="form-check-label" htmlFor="fSCheckCheckedEs" id='fSCheckCheckedEsLabEsgtablero'>Off</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6  mb-2">
                                        <label className="txt_label">Titulo:</label>
                                        <input name="Titulo" id="TitulogtUp" type="text" className="form-control" required />
                                    </div>
                                    <div className="col-sm-12  mb-2">
                                        <label className="txt_label">Descripción:</label>
                                        <textarea name="Nota" id='NotagtUp' className="form-control" rows={5} required></textarea>
                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
                                <button className="btn btn-primary" disabled={LoadUpGTablero}>{LoadUpGTablero ? "enviando..." : "Actualizar"}</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </>

    );


}

export default memo(ModalesInsertsData);

